import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../../api/admin";

const useGetUserClocksQuery = (userId: string) => {
  return useQuery<string[]>({
    queryKey: ["user-clocks", userId],
    queryFn: () => adminApiClient.getUserClocks(userId),
  });
};

export default useGetUserClocksQuery;
